import { Button } from "@wise-emotions/react-button";
import { LangsUi } from "components/Header";
import { MenuNavProps } from "../types";
import { useMenu } from "utilities/MenuProvider";
import MenuItem from "./MenuItem";
import React from "react";
import cn from "classnames";
import dictionary from "configs/dictionary";

const menuLevelComponents = {
  ContentfulMenuTopV2: "MenuTop",
  ContentfulMenuBaseV2: "MenuBase",
  ContentfulMenuGroupV2: "MenuGroup",
  ContentfulMenuListV2: "MenuList",
};

const MenuNav = ({
  children,
  menu,
  currentLevel = 0,
  className,
  classFromParent,
  // NOTE: used only in LINK AUTOMATICO MENU MOBILE (commented)
  // parentPage,
  drowSubmenu = true,
  buttonBack,
}: MenuNavProps) => {
  const menuHelpers = useMenu();
  const { initLevel, privateArea, backMenuMobile } = menuHelpers;

  // TODO: create a type on dictionary
  const ComponentLink =
    dictionary.ContentfulCtaReferenceV2 as React.ElementType;

  const { __typename: typename } = menu;

  const menuNavName = menuLevelComponents[typename];

  const customClass = "";

  const menuNavClass = cn(
    "menuNav",
    "menuNav-level",
    "menuNav__type",
    {
      [`menuNav-level-${currentLevel}`]: true,
      [`menuNav-${menuNavName}`]: true,
      [`menuNav-transition-${initLevel}`]: currentLevel === 0,
    },
    customClass,
    className,
    classFromParent,
  );

  let propsCustom = {};
  if (currentLevel === 0) {
    propsCustom = { ...propsCustom, ...{ "data-level": initLevel } };
  }

  return (
    <div className={menuNavClass} {...propsCustom}>
      {/* LINK AUTOMATICO MENU MOBILE */}
      {/* { parentPage && parentPage.pageReference && (
        <div className="menuNav__parentPage">
          <ComponentLink {...parentPage.pageReference} className="menuNav__parentPage__link">
            {parentPage.label}
          </ComponentLink>
        </div>
      )} */}
      {buttonBack || null}
      {drowSubmenu && (
        <div className="menuNav__wrap">
          <ul className="menuNav__list" role="menu">
            {menu.itemList &&
              menu.itemList.length > 0 &&
              menu.itemList.map((el) => {
                return (
                  <MenuItem data={el} currentLevel={currentLevel} key={el.id} />
                );
              })}
          </ul>
          {children}
        </div>
      )}
      {drowSubmenu && menuNavName && currentLevel === initLevel && (
        <div className="menuNav__utils">
          {/* TODO: gestire creazione login */}
          {privateArea && (
            <div className="menuNav__utils__login">
              <ComponentLink {...privateArea}>
                <Button variant="default" size="md">
                  {privateArea.content[0]?.label}
                </Button>
              </ComponentLink>
            </div>
          )}
          <div className="menuNav__utils__langs">
            <LangsUi />
          </div>
        </div>
      )}
    </div>
  );
};

export default MenuNav;
